"use client";

import Link from "next/link";
import { Stack, Typography, Box } from "@mui/material";
import theme from "@/theme/theme";
import QrCard from "./qrCard";

const ARTICLES = [
    {
        slug: "navigating-the-quantum-shift-our-strategic-partnership-with-pcsi-for-a-quantum-resilient-future",
        title: "Navigating the Quantum Shift: Our Partnership with PCSI",
        description: "How we work with PCSI on the road to a quantum-resilient future, and what it means for organisations preparing today.",
    },
    {
        slug: "quantum-resilient-blockchain-navigating-the-threat-horizon",
        title: "Quantum-Resilient Blockchain: Navigating the Threat Horizon",
        description: "Where the quantum threat meets distributed ledgers, and how to think about resilience before Q-Day arrives.",
    },
];

const QrResources = () => {
    return (
        <Stack
            width={{ xs: "100%", lg: "80%" }}
            marginX="auto"
            paddingX={4}
            gap={6}
            position="relative"
        >
            <Stack gap={2} width={{ xs: "100%", lg: "70%" }}>
                <Typography variant="h3" component="h3" className="chno" fontWeight={400} textTransform="uppercase" fontSize={{ xs: "1.15rem !important", lg: "1.4rem !important" }}>
                    From our blog
                </Typography>
                <Typography variant="body2" component="p" fontSize="0.95rem !important" color={theme.palette.text.secondary} fontWeight={400}>
                    We write about the quantum transition as it develops. Two pieces worth starting with:
                </Typography>
            </Stack>
            <Stack direction={{ xs: "column", md: "row" }} gap={3}>
                {ARTICLES.map((article) => (
                    <Box
                        key={article.slug}
                        component={Link}
                        href={`/article/${article.slug}`}
                        sx={{ flex: 1, textDecoration: "none", display: "block" }}
                    >
                        <QrCard sx={{ height: "100%" }}>
                            <Stack gap={1.5} height="100%">
                                <Typography variant="h6" component="h4" fontWeight={400} fontSize="1.05rem !important" color={theme.palette.text.primary}>
                                    {article.title}
                                </Typography>
                                <Typography variant="body2" component="p" fontSize="0.85rem !important" color={theme.palette.text.secondary} fontWeight={400}>
                                    {article.description}
                                </Typography>
                                <Typography component="span" fontSize="0.8rem !important" color={theme.palette.brand.mgsLightBlue1.main} marginTop="auto">
                                    Read article &rarr;
                                </Typography>
                            </Stack>
                        </QrCard>
                    </Box>
                ))}
            </Stack>
        </Stack>
    );
};

export default QrResources;
